// Shared loading indicator. Replaces the ad-hoc loaders that each page used
// to roll on its own (`.stats-loading`, `.profile-status`, `.auth-msg`
// "Loading…", `.auth-loading`, the inline `ScoreLoading`, etc.). Renders the
// one real animated spinner the app already had (the wizard-invite waiting
// spinner) plus a message.
//
// Props:
//   message  text shown under the spinner (default "Loading…")
//   compact  smaller spinner + tighter padding, for inline/in-panel spots
//   className extra classes appended to the wrapper

export function Loading({ message = "Loading…", compact = false, className = "" }) {
  const cls = ["loading", compact ? "loading--compact" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} role="status">
      <span className="loading-spinner" aria-hidden="true" />
      <span className="loading-msg">{message}</span>
    </div>
  );
}
